<template>
    <div>
        <div>
            <div style="font-size:7rem;">식단표앱 필요하세요?</div>
            <div style="font-size:2rem; color:grey">알람, 댓글, 여러 식당 선택, 자유로운 메뉴 구조 설정</div>
            <div style="height:20px"></div>
            <div style="font-size:3rem; color:grey">이 모든게 무료</div>
        </div>

        <div style="height:50px"></div>

        <div style="font-size: 1.2rem;">
            상담이 필요하신가요?
            <div>
                <a href="https://open.kakao.com/o/snxE8uCd" target="_blank">


                    식단표장인과 1:1 채팅
                </a> 또는 <a href="tel:010-9307-5807">010-9307-5807</a>
            </div>
        </div>
        <div style="height:50px"></div>
        <div>
            <router-link to="/app">
                <v-btn color="blue darken-3" dark large style="height:70" @click="showSideBar">
                    <div style="font-size: 2rem;">
                        식단표 입력 시작하기
                    </div>
                </v-btn>
            </router-link>
        </div>
        <div style="height:50px"></div>

        <div class="landing-production-cards">

            <div>
                <v-card class="mx-auto" max-width="300">
                    <img style=" max-width:300px; " src="../assets/gune_3.jpg">
                    <v-card-text>
                        <div>여러 식당을 선택 가능합니다</div>

                    </v-card-text>
                </v-card>
            </div>
            <div>
                <v-card class="mx-auto" max-width="300">
                    <img style=" max-width:300px; " src="../assets/gune_2.jpg">
                    <v-card-text>
                        <div> 댓글 피드백을 쉽게 받을수 있습니다</div>

                    </v-card-text>

                </v-card>
            </div>

        </div>
        <div style="height:20px"></div>
        <div class="download-section">
            <div class="download-title">
                조선소 식단표 앱 다운로드
            </div>
            <div class="download-subtitle">
                아이폰, 안드로이드 스토어에서 무료로 이용해보세요!
            </div>

            <div class="store-links">
                <a href="https://play.google.com/store/apps/details?id=com.gune.josenso&hl=ko" target="_blank"
                    style="text-decoration: none;">
                    <v-btn large color="#00897B" dark class="store-btn google-play-btn">
                        <v-icon left>mdi-google-play</v-icon>
                        Google Play
                    </v-btn>
                </a>
                <a href="https://apps.apple.com/kr/app/%EC%A1%B0%EC%84%A0%EC%86%8C-%EC%8B%9D%EB%8B%A8%ED%91%9C/id1500457086"
                    target="_blank" style="text-decoration: none;">
                    <v-btn large color="black" dark class="store-btn app-store-btn">
                        <v-icon left>mdi-apple</v-icon>
                        App Store
                    </v-btn>
                </a>
            </div>
            <div class="download-desc">
                현재 14곳의 식단표앱을 운영중입니다.<br>
                스샷 이외의 많은 기능들을 직접 다운받으셔서 이용해보세요.
            </div>
        </div>


    </div>
</template>

<script>
export default {
    methods: {
        showSideBar: function () {
            this.$store.state.isOpenSideBar = true;
        },
    }
}
</script>
<style scoped>
.landing-production-cards {
    display: flex;
    flex-direction: row;

    justify-content: space-around;

}

.v-btn {
    height: 80px;
}

.download-section {
    margin-top: 40px;
    padding: 40px 20px;
    background-color: #f7f9fc;
    border-radius: 16px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.download-title {
    font-size: 1.8rem;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 8px;
}

.download-subtitle {
    font-size: 1.1rem;
    color: #5b6977;
    margin-bottom: 24px;
}

.store-links {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.store-btn {
    height: 56px !important;
    border-radius: 8px;
    font-size: 1.1rem;
    letter-spacing: 0;
    text-transform: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.google-play-btn {
    background-color: #00897B !important;
}

.app-store-btn {
    background-color: #000000 !important;
}

.download-desc {
    font-size: 0.95rem;
    color: #8a96a3;
    line-height: 1.6;
}
</style>